import React from "react"
// import { Spinner } from "react-bootstrap"

const Loader = () => {
  return <React.Fragment>{/* <Spinner /> */}</React.Fragment>
}

export default Loader
